import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { loadGoogleTag } from "@/lib/gtag";

export const SiteLayout = ({ children }) => {
  useEffect(() => { loadGoogleTag(); }, []);
  return (
    <div className="min-h-screen flex flex-col bg-stone-bg">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
};
